import React from 'react';

export default function InstructorCertificationPolicy() {
  return (
    <div className="bg-white min-h-screen flex flex-col py-10 px-2">
      <div className="max-w-3xl mx-auto bg-white rounded-xl shadow-xl border border-gray-200 p-8">

        <h1 className="text-3xl font-bold text-purple-600 mb-6 text-center">
          Instructor Certification Policy
        </h1>

        <p className="text-gray-700 mb-8">
          Million2Trillion (M2T) maintains strict instructor onboarding standards to ensure that educators, trainers, mentors, and signal providers meet verified professional qualifications.
        </p>

        <h2 className="text-2xl font-semibold text-blue-900 mt-8 mb-2">Instructor Verification Process</h2>
        <ul className="list-disc text-gray-700 space-y-3 pl-6 mb-6">
          <li>All instructors must complete full KYC identity verification.</li>
          <li>Instructors must submit certification of skills, licenses, or credentials related to financial markets, technical analysis, or investment training.</li>
          <li>Applicants must provide a full teaching profile including prior experience, subject areas, and student success rates (where available).</li>
          <li>Platform administrators may conduct interview rounds or trial training review before granting instructor status.</li>
        </ul>

        <h2 className="text-2xl font-semibold text-blue-900 mt-8 mb-2">Instructor Responsibility</h2>
        <ul className="list-disc text-gray-700 space-y-3 pl-6 mb-6">
          <li>Instructors must maintain content accuracy, honesty, and practical value in their education materials.</li>
          <li>No guaranteed returns, unrealistic income claims, or financial promises are permitted.</li>
          <li>Instructors must remain accessible for student support and mentorship as per agreed training schedules.</li>
        </ul>

        <h2 className="text-2xl font-semibold text-blue-900 mt-8 mb-2">Continuous Certification Review</h2>
        <ul className="list-disc text-gray-700 space-y-3 pl-6 mb-6">
          <li>M2T reserves full rights to periodically re-verify instructor qualifications to ensure compliance with evolving standards.</li>
          <li>Violation of instructor conduct policies may lead to warnings, account suspension, removal from search listings, or permanent account ban.</li>
        </ul>

        <p className="text-gray-500 italic mt-10">
          Verified instructors represent the education foundation of M2T. Only qualified, ethical, and trustable educators are permitted inside the verified market learning system.
        </p>
      </div>
    </div>
  );
}
